// base URLs
const { VITE_GESTIFY_API_URL, VITE_GESTIFY_API_URL_AUTH } = process.env || {};
export const API_GESTIFY_AUTH_URL = VITE_GESTIFY_API_URL_AUTH;
export const API_GESTIFY_URL = VITE_GESTIFY_API_URL;

// sections
export const URL_ALLEGATI = '/allegati';
export const URL_ANAGRAFICA = '/anagrafica';
export const URL_ANAGRAFICA_CONTATTI = '/contatti';
export const URL_ANAGRAFICA_EMAILS = '/email';
export const URL_ANAGRAFICA_SEDI_AGGIUNTIVE = '/sedi_aggiuntive';
export const URL_ATECO = '/ateco';
export const URL_BANCHE_DATI = '/banche_dati';
export const URL_CENTRI_COSTO = '/tab_centri_costo';
export const URL_CENTRI_RICAVO = '/tab_centri_ricavo';
export const URL_CODICE_CONFERMA = '/codice_conferma';
export const URL_COMMENTI = '/commenti';
export const URL_COMUNICAZIONI = '/comunicazioni';
export const URL_CONFIGURAZIONE_REPORT = '/report_configurazione';
export const URL_CONFIGURAZIONE_AZIENDA = '/configurazione_azienda';
export const URL_CONFIGURAZIONE_PROGETTI = '/configurazione_progetti';
export const URL_DOCUMENTI = '/documenti';
export const URL_DOCUMENTI_LINK = '/documenti_link';
export const URL_GEO = '/geo';
export const URL_HELP = '/help';
export const URL_ARGOMENTI = '/argomenti';
export const URL_IMPOSTAZIONI = '/impostazioni';
export const URL_AZIENDA = '/azienda';
export const URL_INVITI = '/inviti';
export const URL_MAGAZZINO = '/magazzino';
export const URL_MAGAZZINO_SCONTISTICHE = '/scontistiche';
export const URL_MAGAZZINO_VARIANTI = '/varianti';
export const URL_NOTIFICHE = '/notifiche';
export const URL_ORARI = '/orari';
export const URL_REPORT = '/report';
export const URL_ELENCO = '/elenco';
export const URL_ORDINI_SERVIZIO = '/ordini_servizio';
export const URL_CONTO_VIRTUALE = '/conti_virtuali';
export const URL_PAGAMENTO_METODI = '/pagamento_metodi';
export const URL_PAGAMENTO_TERMINI = '/pagamento_termini';
export const URL_PIANO_CONTI = '/tab_piano_conti';
export const URL_PRIMA_NOTA = '/prima_nota';
export const URL_PROFILO_AZIENDA = '/profilo_azienda';
export const URL_REGOLE = '/regole';
export const URL_SEZIONALI = '/sezionali';
export const URL_SISTEMA = '/sistema';
export const URL_SYSTEM = '/system';
export const URL_TAB_CAUSALI_PRIMA_NOTA = '/tab_prima_nota_causali';
export const URL_TAB_CAUSALI_RITENUTA = '/tab_fe_ritenuta_causali';
export const URL_TAB_CAUSALI_SPEDIZIONE = '/tab_causali_spedizione';
export const URL_TAB_CONTI = '/tab_conti';
export const URL_TAB_DEPOSITI = '/tab_depositi';
export const URL_TAB_FE = '/fe_tabelle';
export const URL_TAB_IVA = '/tab_iva';
export const URL_TAB_UNITA_MISURA = '/tab_unita_misura';
export const URL_TAB_VETTORI = '/tab_vettori';
export const URL_TABELLE = '/tabelle';
export const URL_USER = '/user';
export const URL_UTENTI = '/utenti';
export const URL_UTENTI_INVITI = '/utenti_e_inviti';
export const URL_SCADENZARIO = '/scadenzario';
export const URL_STATISTICHE = '/statistiche';
export const URL_RIVENDITORI_SEGNALAZIONI = '/rivenditori_segnalazioni';
export const URL_SALDO = '/saldo';
export const URL_PREZZI_SPECIALI = '/prezzi_speciali';
export const URL_AUTOFATTURA = '/autofattura';
export const URL_MULTI_LIVELLO = '/multi_livello';
export const URL_INVENTARIO = '/inventario';
export const URL_GRUPPI = '/gruppi';
export const URL_DESTINATARI = '/destinatari';
export const URL_PIANIFICAZIONE = '/pianificazione';
export const URL_QUALIFICHE = '/qualifiche';
export const URL_VARIANTI = '/varianti';
export const URL_TAB_PRIORITA = '/tab_priorita';
export const URL_TAB_ATTIVITA_DESCRITTIVE = '/tab_attivita_descrittive';
export const URL_GESTIFY_AUTH = '/gestify-auth';
export const URL_GESTIFY_SEZIONALI = '/gestify-sezionali';
export const URL_GESTIFY_ANAGRAFICHE = '/gestify-anagrafiche';
export const URL_GESTIFY_DOCUMENTI = '/gestify-documenti';
export const URL_GESTIFY_DOCUMENTI_RIGHE = '/gestify-documenti-righe';

// auth sections
export const URL_AUTH = '/auth';
export const URL_AZIENDE = '/aziende';
export const URL_TENANT = '/tenant';
export const URL_ATTIVA = '/attiva';
export const URL_SERVIZI = '/servizi';
export const URL_BILLING = '/billing';
export const URL_PIANO_TARIFFARIO = '/piano_tariffario';
export const URL_PIANI_TARIFFARI = '/piani_tariffari';
export const URL_CODICI_PROMOZIONALI = '/codici_promozionali';

// backoffice sections
export const URL_BACKOFFICE = '/backoffice';
export const URL_CASSE_PREVIDENZIALI = '/casse_previdenziali';
export const URL_FE_CAUSALI = '/fe_causali';
export const URL_FE_DATI = '/fe_dati';
export const URL_FE_DATI_AGGIUNTIVI = '/fe_dati_aggiuntivi';
export const URL_FE_DATI_DDT = '/fe_dati_ddt';
export const URL_FE_DATI_GESTIONALI = '/fe_dati_gestionali';
export const URL_GUIDA = '/guida';
export const URL_HELPDESK = '/helpdesk';
export const URL_SUPPORTO = '/supporto';
export const URL_TICKET = '/ticket';
export const URL_GUIDA_TESTI = '/guida_testi';
export const URL_MODULI = '/moduli';
export const URL_POSIZIONI = '/posizioni';
export const URL_PROFILI = '/profili';
export const URL_RIGHE = '/righe';
export const URL_SCADENZE = '/scadenze';
export const URL_FE = '/fe';
export const URL_RICEVUTE = '/ricevute';
export const URL_ATTIVE = '/attive';
export const URL_STATI = '/stati';

// versions
export const URL_V1 = '/v1';
export const URL_V2 = '/v2';

// endpoints

// documenti endpoints
export const URL_RICALCOLA = '/ricalcola';
export const URL_SCONTI_QTA = '/sconti_qta';
// dati gestionali
export const URL_PROPAGA_RIGHE = '/propaga_righe';
export const URL_SVUOTA_RIGHE = '/svuota_righe';

// users endpoints
export const URL_EMAIL_CHANGE = '/email_change_request';
export const URL_SESSION = '/session';
export const URL_CHANGE = '/change';
export const URL_INIT = '/init';
export const URL_EMAIL_CHANGE_VERIFY = '/email_change_verify';
export const URL_LOGIN = '/login';
export const URL_TEAM = '/team';
export const URL_ABBANDONA = '/abbandona';
export const URL_LOGOUT = '/logout';
export const URL_PASSWORD_CHANGE = '/password_change';
export const URL_LOGIN_CHECK_PASSWORD = '/login_check_password';
export const URL_PASSWORD_RESET_REQUEST = '/password_reset_request';
export const URL_PASSWORD_RESET_VERIFY = '/password_reset_verify';
export const URL_REFRESH = '/refresh';
export const URL_AGGIORNAMENTO_MASSIVO = '/aggiornamento_massivo';

// impostazioni endpoints
export const URL_PREDEFINITI = '/predefiniti';
export const URL_DASHBOARD = '/dashboard';
export const URL_DASHBOARD_NEWS = '/news';
export const URL_DASHBOARD_COMUNICAZIONI = '/comunicazioni';

// utenti endpoints
export const URL_REGISTER = '/register';

// system endpoints
export const URL_VERIFICA = '/verifica';
export const URL_INVIA = '/invia';

// other endpoints
export const URL_AGGIORNAMENTO = '/aggiornamento';
export const URL_PREZZI = '/prezzi';
export const URL_AGGIORNA = '/aggiorna';
export const URL_DISPONIBILI = '/disponibili';
export const URL_CONFERMA_REGISTRAZIONE = '/conferma_registrazione';
export const URL_RICHIESTA = '/richiesta';
export const URL_CONFERMA = '/conferma';
export const URL_GENERALI = '/generali';
export const URL_EMPTY = '/svuota';
export const URL_FILL = '/riempi';
export const URL_ENTRATE = '/entrate';
export const URL_USCITE = '/uscite';
export const URL_TUTTO = '/tutto';
export const URL_OPERAZIONI = '/operazioni';
export const URL_RISPONDI = '/rispondi';
export const URL_EMAIL_SEND = '/email_send';
export const URL_SOLLECITI = '/solleciti';
export const URL_EFFETTI = '/effetti';
export const URL_SDD = '/SDD';
export const URL_RIBA = '/RIBA';
export const URL_CHECK = '/check';
export const URL_SELEZIONATI = '/selezionati';
export const URL_RICERCA = '/ricerca';
export const URL_ELABORA = '/elabora';
export const URL_ANAGRAFICHE = '/anagrafiche';
export const URL_ALLINEA = '/allinea';
export const URL_UTILIZZO = '/utilizzo';
export const URL_NODI = '/nodi';
export const URL_RISCATTA = '/riscatta';
export const URL_TAGGATURA = '/taggatura';
export const URL_PUBBLICA = '/pubblica';
export const URL_ELIMINAZIONI = '/eliminazioni';
// common endpoints
export const URL_ALL = '/all';
export const URL_CREATE = '/create';
export const URL_SALDI = '/saldi';
export const URL_DUPLICA = '/duplica';
export const URL_COLLEGA = '/collega';
export const URL_SPOSTA_RIGHE_PROGETTO = '/sposta_righe_progetto';
export const URL_RIAPRI = '/riapri';
export const URL_NUOVO = '/nuovo';
export const URL_CREATE_MULTI = '/create_multi';
export const URL_DELETE = '/delete';
export const URL_DELETE_MULTI = '/delete_multi';
export const URL_TAGGATI = '/taggati';
export const URL_STAT = '/stat';
export const URL_DOWNLOAD = '/download';
export const URL_COLONNE = '/colonne';
export const URL_ITEM = '/item';
export const URL_TRASFORMA = '/trasforma';
export const URL_LIST = '/list';
export const URL_LOG = '/log';
export const URL_ME = '/me';
export const URL_MARK_AS = '/set';
export const URL_PRENOTA = '/prenota';
export const URL_LOCK = '/lock';
export const URL_REQUEST = '/request';
export const URL_RESPONSE = '/response';
export const URL_MOVIMENTAZIONI = '/movimentazioni';
export const URL_UNLOCK = '/unlock';
export const URL_UPDATE = '/update';
export const URL_UPLOAD = '/upload';
export const URL_GIACENZA = '/giacenza';
export const URL_RETTIFICA = '/rettifica';
export const URL_UTENTE = '/utente';
export const URL_XML_CREA = '/xml_crea';
export const URL_XML = '/xml';
export const URL_FILE = '/file';
export const URL_ESITI = '/esiti';
export const URL_INVIO_STATO = '/invio_stato';
export const URL_BLOCCO = '/blocco';
export const URL_FATTURAZIONE = '/fatturazione';
export const URL_FATTURA = '/fattura';
export const URL_CREA_INVIA = '/crea_invia';
export const URL_GENERATE = '/generate';
export const URL_TEMPLATE = '/template';
export const URL_IMPORT = '/importazione';
export const URL_IMPORTA = '/importa';
export const URL_ASSOCIA = '/associa';
export const URL_SPOSTA = '/sposta';
export const URL_COPIA = '/copia';
export const URL_RIEPILOGHI = '/riepiloghi';
export const URL_PREFERENZE = '/preferenze';
export const URL_PERMS = '/perms';
export const URL_SET = '/set';
export const URL_SET_MULTI = '/set_multi';
export const URL_LISTINI_CUSTOM = '/listini_custom';
export const URL_VARIAZIONE = '/variazione';
export const URL_BARCODE = '/barcode';
export const URL_MAINTENANCE = '/maintenance';
export const URL_FORNITORI = '/fornitori';
export const URL_AGGREGAZIONI = '/aggregazioni';
export const URL_CHIUDI = '/chiudi';
export const URL_OPZIONI = '/opzioni';
export const URL_GLOBALI = '/globali';
export const URL_SALDO_IVA = '/saldo_iva';
export const URL_RIEPILOGO = '/riepilogo';
export const URL_CHECK_VALIDITA = '/check_validita';
export const URL_CREATE_MASSIVA = '/create_massiva';

// tables
export const URL_TAB_FASI = 'tab_fasi';
export const URL_TAB_CATEGORIA_1 = 'tab_categoria_1';
export const URL_TAB_CATEGORIA_2 = 'tab_categoria_2';
export const URL_TAB_CLASSIFICAZIONE_1 = 'tab_classificazione_1';
export const URL_TAB_CLASSIFICAZIONE_2 = 'tab_classificazione_2';
export const URL_TAB_COMUNI = '/comuni';
export const URL_TAB_NAZIONI = '/nazioni';
export const URL_TAB_PROVINCE = '/province';
export const URL_TAB_REGIONI = '/regioni';

// aziende auth
export const URL_ARCHIVIA = '/archivia';
export const URL_INFO = '/info';
export const URL_REOPEN = '/riapri';

// xml operations
export const URL_OPERATION_XML = '/XML';
export const URL_OPERATION_INV = '/INV';
export const URL_OPERATION_EXP = '/EXP';

// progetti
export const URL_PROGETTI = '/progetti';
export const URL_UTENTI_RISORSE = '/utenti_risorse'; // Livello globale
export const URL_PROGETTI_COMMESSE = '/commesse'; // Livello progetti
export const URL_PROGETTI_UTENTI_RISORSE = '/utenti_risorse'; // Livello progetti
export const URL_PROGETTI_QUALIFICHE = '/qualifiche'; // Livello progetti
export const URL_PROGETTI_SPESE_ACCESSORIE = '/spese_accessorie'; // Livello progetti
export const URL_PROGETTI_RAPPORTINI = '/rapportini'; // Livello progetti
export const URL_PROGETTI_CONTABILITA = '/contabilita'; // Livello progetti
export const URL_PROGETTI_OFFERTE = '/offerte'; // Livello progetti
export const URL_PROGETTI_RIGHE = '/righe'; // Livello progetti
export const URL_PROGETTI_DOCUMENTI = '/documenti'; // Livello progetti
export const URL_PROGETTI_STAT = '/stat'; // Livello progetti
export const URL_PROGETTI_SCOLLEGA = '/scollega'; // Livello progetti
export const URL_DDT_RESO = '/ddt_reso';
export const URL_TAB_AUTOMEZZI = '/tab_automezzi';
export const URL_TAB_PROGETTI_FASI = '/tab_progetti_fasi';
export const URL_TAB_QUALIFICHE = '/tab_manodopera_qualifiche';
export const URL_TAB_QUALIFICHE_VARIANTI =
  '/tab_manodopera_qualifiche_varianti';
export const URL_TAB_SPESE_ACCESSORIE = '/tab_spese_accessorie';
export const URL_PROGETTI_RIGHE_MANODOPERA = '/righe_manodopera';
export const URL_RISORSE = '/risorse';

// listini
export const URL_LISTINI = '/listini';
export const URL_LISTINI_MARCHE = '/marche';
export const URL_LISTINI_PRODOTTI = '/prodotti';

//interventi
export const URL_INTERVENTI = 'interventi';
export const URL_TAB_INTERVENTI_FASI = '/tab_interventi_fasi';
export const URL_TAB_INTERVENTI_CATEGORIE = '/tab_interventi_categorie';
export const URL_RIGHE_MANODOPERA = '/righe_manodopera';
